import LoginPage from "views/Auth/Login/LoginPage";

import { Route, Routes } from "react-router-dom";
import { useState } from "react";
import { AuthRoute } from "routing";
import { MainPage } from "views/Admin/MainPage";



const AdminRoutes = () => {
    
  const [activeToolbar, setActiveToolbar] = useState(null);

  return (
    <Routes>
      
      <Route path='/login' element={<LoginPage />}/>

      
      <Route element={<AuthRoute />}>

            <Route path='/*' element={<MainPage />} /> 
            
              
      </Route>
    </Routes>
  ) ; 
  

};

export default AdminRoutes;